import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconPersonLock12 from './IconPersonLock12';
import IconPersonLock16 from './IconPersonLock16';
import IconPersonLock20 from './IconPersonLock20';
import IconPersonLock24 from './IconPersonLock24';
import IconPersonLock32 from './IconPersonLock32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconPersonLock = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconPersonLock12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconPersonLock16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconPersonLock20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconPersonLock24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconPersonLock32 {...props} />}
        </span>
    );
};
IconPersonLock.displayName = 'FondueIconPersonLock';

export default memo(IconPersonLock);
